/* istanbul ignore file */
import { Icon, Dropdown } from '@distribusion/owl-frontend-ui'
import { addMonths, format, isSameMonth } from 'date-fns'
import React, { useMemo } from 'react'

import config from '@config'
import bem from '@lib/bem'
import i18n from '@lib/i18n'
import { useParams } from '@stores/params'

import '@ui/MonthPicker/index.scss'

interface MonthPickerProps {
  selectedMonth: string | null
  onMonthSelect: (value: string) => void
  label: string
  errorMessage?: string | null
}

const MonthPicker = ({ selectedMonth, errorMessage, onMonthSelect, label }: MonthPickerProps) => {
  const [pageParams] = useParams()

  const monthItems = useMemo(() => {
    const { months: subscriptionStart } = config.subscriptionStart[pageParams.retailerPartnerNumber]

    const items = Array.from({ length: subscriptionStart }, (_, index) => {
      const today = new Date()
      const date = addMonths(today, index)
      const label = date.toLocaleString(i18n.getLanguage(), {
        month: 'long',
        year: 'numeric',
      })

      let value: string
      if (isSameMonth(date, today)) {
        value = format(today, 'yyyy-MM-dd')
      } else {
        value = format(date, 'yyyy-MM-01')
      }

      return { label, value, selectedLabel: label }
    })

    return items
  }, [pageParams.retailerPartnerNumber])

  return (
    <Dropdown
      items={monthItems}
      value={selectedMonth}
      icon={<Icon name="calendar" size="large" />}
      onChange={onMonthSelect}
      label={label}
      errorMessage={errorMessage}
      className={bem('month-picker', 'dropdown')}
    />
  )
}

export default MonthPicker
